import { z } from 'zod'

export const viewerSchema = z.object({
  signedIn: z.boolean(),
  vehicle: z.object({ id: z.string(), name: z.string() }).nullable(),
  wishIds: z.array(z.string()),
  cartCount: z.number().int().min(0),
})

export type Viewer = z.infer<typeof viewerSchema>
